/**
 * Konfigurasi API untuk aplikasi PAK MoO
 * Menggunakan environment variables dari file .env
 */

// Base URL API - ambil dari environment variable
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Timeout untuk request API (dalam milliseconds)
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10);

// Konfigurasi aplikasi
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'PAK MoO';
export const APP_VERSION = process.env.REACT_APP_APP_VERSION || '1.0.0';
export const APP_ENV = process.env.REACT_APP_ENV || 'development';

// Konfigurasi WhatsApp
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '6281234567890';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    PROFILE: '/api/auth/profile',
  },
  
  // User
  USER: {
    CREATE: '/api/users',
    GET_ME: '/api/users/me',
    GET_BY_ID: (userId) => `/api/users/${userId}`,
    UPDATE_BY_ID: (userId) => `/api/users/${userId}`,
    UPDATE_PASSWORD: (userId) => `/api/users/${userId}/password`,
    GET_PROFILE: '/api/user/profile',
    UPDATE_PROFILE: '/api/user/profile',
    CHANGE_PASSWORD: '/api/user/change-password',
  },
  
  // Catalog / Sapi
  CATALOG: {
    LIST: '/api/catalog',
    DETAIL: (id) => `/api/catalog/${id}`,
    SEARCH: '/api/catalog/search',
  },
  
  // Kategori Produk
  KATEGORI_PRODUK: {
    LIST: '/api/kategori-produk/public',
  },
  
  // Produk Public
  PRODUK: {
    PUBLIC_LIST: '/api/produk/public',
    PUBLIC_DETAIL: (id) => `/api/produk/public/${id}`,
    PUBLIC_IMAGES: (id) => `/api/produk/public/${id}/images`,
    DETAIL: (id) => `/api/produk/${id}`,
  },
  
  // Timbangan Produk Public
  TIMBANGAN_PRODUK: {
    PUBLIC_LIST: '/api/timbangan-produk/public',
    PUBLIC_BY_PRODUK: (produkId) => `/api/timbangan-produk/public/${produkId}`,
    PUBLIC_BY_PRODUK_QUERY: (produkId) => `/api/timbangan-produk/public?id_produk=${produkId}`,
    LIST: '/api/timbangan-produk',
    BY_PRODUK: (produkId) => `/api/timbangan-produk?id_produk=${produkId}`,
    IMAGES: (produkId) => `/api/timbangan-produk/${produkId}/images`,
  },

  // Vaksin Produk
  VAKSIN_PRODUK: {
    LIST: '/api/vaksin-produk',
    PUBLIC_LIST: '/api/vaksin-produk/public',
    BY_PRODUK: (produkId) => `/api/vaksin-produk?id_produk=${produkId}`,
    PUBLIC_BY_PRODUK: (produkId) => `/api/vaksin-produk/public?id_produk=${produkId}`,
    IMAGES: (vaksinProdukId) => `/api/vaksin-produk/${vaksinProdukId}/images`,
  },
  
  // Tabungan
  TABUNGAN: {
    LIST: '/api/tabungan',
    DETAIL: (id) => `/api/tabungan/${id}`,
    CREATE: '/api/tabungan',
    UPDATE: (id) => `/api/tabungan/${id}`,
  },
  
  // Investasi
  INVESTASI: {
    LIST: '/api/investasi',
    DETAIL: (id) => `/api/investasi/${id}`,
    CREATE: '/api/investasi',
    BY_USER: (userId) => `/api/investasi/user/${userId}`,
  },

  // Investasi Produk
  INVESTASI_PRODUK: {
    LIST: '/api/investasi-produk',
    DETAIL: (id) => `/api/investasi-produk/${id}`,
    CREATE: '/api/investasi-produk',
    BY_INVESTASI: (investasiId) => `/api/investasi-produk/investasi/${investasiId}`,
  },
  
  // Transaksi
  TRANSAKSI: {
    LIST: '/api/transaksi',
    DETAIL: (id) => `/api/transaksi/${id}`,
    CREATE: '/api/transaksi',
  },
  
  // Promo & Berita
  PROMO: {
    LIST: '/api/promo',
    DETAIL: (id) => `/api/promo/${id}`,
  },
  
  BERITA: {
    LIST: '/api/berita',
    DETAIL: (id) => `/api/berita/${id}`,
  },

  // Artikel
  ARTIKEL: {
    PUBLIC_LIST: '/api/artikel/public',
    PUBLIC_DETAIL: (id) => `/api/artikel/public/${id}`,
    PUBLIC_BY_SLUG: (slug) => `/api/artikel/public/slug/${slug}`,
  },
  
  // Pembayaran
  PEMBAYARAN: {
    CREATE: '/api/pembayaran',
    LIST: '/api/pembayaran',
    DETAIL: (id) => `/api/pembayaran/${id}`,
    VERIFY: (id) => `/api/pembayaran/${id}/verify`,
    BY_TABUNGAN: (tabunganId) => `/api/pembayaran/by-tabungan/${tabunganId}`,
    BY_INVESTASI: (investasiId) => `/api/pembayaran/by-investasi/${investasiId}`,
    IMAGES: (entityId) => `/api/pembayaran/${entityId}/images`,
  },

  // Dokumen
  DOKUMEN: {
    CREATE: '/api/dokumen',
    LIST: '/api/dokumen',
    DETAIL: (id) => `/api/dokumen/${id}`,
    BY_TABUNGAN: (tabunganId) => `/api/dokumen?tabungan_id=${tabunganId}`,
    BY_INVESTASI: (investasiId) => `/api/dokumen?investasi_id=${investasiId}`,
    UPLOAD: (entityId) => `/api/dokumen/${entityId}/upload`,
    FILES: (entityId) => `/api/dokumen/${entityId}/files`,
  },

  // Invoice
  INVOICE: {
    CREATE: '/api/invoice',
    LIST: '/api/invoice',
    DETAIL: (id) => `/api/invoice/${id}`,
    BY_TABUNGAN: (tabunganId) => `/api/invoice?tabungan_id=${tabunganId}`,
    BY_INVESTASI: (investasiId) => `/api/invoice?investasi_id=${investasiId}`,
    UPLOAD: (entityId) => `/api/invoice/${entityId}/upload`,
    FILES: (entityId) => `/api/invoice/${entityId}/files`,
  },

  // Pengiriman
  PENGIRIMAN: {
    CREATE: '/api/pengiriman',
    LIST: '/api/pengiriman',
    DETAIL: (id) => `/api/pengiriman/${id}`,
    BY_TABUNGAN: (tabunganId) => `/api/pengiriman?tabungan_id=${tabunganId}`,
    BUKTI_IMAGES: (entityId) => `/api/pengiriman/${entityId}/bukti`,
    RESI_IMAGES: (entityId) => `/api/pengiriman/${entityId}/resi`,
  },
  
  // Mitra
  MITRA: {
    PUBLIC_BY_USER: (userId) => `/api/mitra/public/user/${userId}`,
    PUBLIC_PRODUK: (mitraId, limit = 10, offset = 0) => `/api/mitra/public/${mitraId}/produk?limit=${limit}&offset=${offset}`,
    PUBLIC_ALL_PRODUK: (mitraId) => `/api/mitra/public/${mitraId}/all-produk`,
  },
  
  // Health Check
  HEALTH: '/health',
};

/**
 * Helper function untuk mendapatkan full URL dari endpoint
 * @param {string} endpoint - Endpoint path
 * @returns {string} Full URL
 */
export const getApiUrl = (endpoint) => {
  // Jika endpoint sudah full URL, return as is
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  
  // Pastikan API_BASE_URL tidak berakhir dengan slash
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  
  // Pastikan endpoint dimulai dengan slash
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${baseUrl}${path}`;
};

/**
 * Helper function untuk mendapatkan full URL dari gambar
 * @param {string} imageUrl - Image URL dari API (bisa relatif atau absolut)
 * @returns {string} Full URL gambar
 */
export const getImageUrl = (imageUrl) => {
  // Jika sudah full URL, return as is
  if (!imageUrl) return '';
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // Pastikan API_BASE_URL tidak berakhir dengan slash
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  
  // Pastikan imageUrl dimulai dengan slash
  const path = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  
  // Build full URL
  return `${baseUrl}${path}`;
};

// Export default untuk kemudahan penggunaan
export default {
  API_BASE_URL,
  API_TIMEOUT,
  APP_NAME,
  APP_VERSION,
  APP_ENV,
  WHATSAPP_NUMBER,
  API_ENDPOINTS,
  getApiUrl,
  getImageUrl,
};

